import { render, staticRenderFns } from "./VPasswordWithValidation.vue?vue&type=template&id=5c06360e&scoped=true"
import script from "./VPasswordWithValidation.vue?vue&type=script&lang=ts"
export * from "./VPasswordWithValidation.vue?vue&type=script&lang=ts"
import style0 from "./VPasswordWithValidation.vue?vue&type=style&index=0&id=5c06360e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c06360e",
  null
  
)

export default component.exports